/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { sandboxSetPricing } from "../../funcs/sandboxSetPricing.js";
import * as components from "../../models/components/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: components.SandboxPricingUpdate$inboundSchema,
};

export const tool$sandboxSetPricing: ToolDefinition<typeof args> = {
  name: "sandbox-set-pricing",
  description: `Set Sandbox Pricing

Replace the sandbox pricing rate card. Full-replace semantics: SKUs omitted from the request become unpriced and accrue no spend. Takes effect on the next meter window without a restart. Cluster admins only.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await sandboxSetPricing(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
